import vipDictionary from '../../ru/vip/vip.dic.json';

export const vipNS = {
  VIP: vipDictionary,
};

export const vipNamespaces = ['VIP'];
